import { Payload, UseCase } from '@smile-next/uikit';

export class DisplayedErrorMessagePayload extends Payload {
    type = 'DisplayedErrorMessagePayload';
    constructor(
        public readonly errorMessage?: string,
        public readonly additionalMessageSummary?: string,
        public readonly additionalMessageDetails?: string,
    ) {
        super();
    }
}

export class DisplayErrorMessageUseCase extends UseCase {
    execute(error: string, errorDescription: string) {
        let errorMessage: string | undefined;
        let additionalMessageSummary: string | undefined;
        let additionalMessageDetails: string | undefined;
        switch (error) {
            case 'invalid_request':
                // クライアントシークレットの有効期限切れや、無効なクライアントシークレットをカスタマーサイトのSSO設定に
                // 入力した場合、errorDescriptionに「${クラウドID} Error - 401 invalid_client AADSTS7000222: The provided client secret keys for app '${シークレットトークンの値}' are expired. Visit the Azure portal to create new keys for your app: https://aka.ms/NewClientSecret, or consider using certificate credentials for added security: https://aka.ms/certCreds. Trace ID: f83615a0-ceeb-4eea-a06e-9eb080caa700 Correlation ID: 06130993-097a-4a65-be5a-66f16bcbc51d Timestamp: 2024-09-26 06:36:04Z」がセットされる。
                // そのような場合のエラーメッセージを適切にするため分岐する。
                if (/^\w{11} Error - \d+ invalid_client.*$/.test(errorDescription)) {
                    errorMessage = 'シングルサインオンによるログインができませんでした。管理者に連絡してください。';
                    additionalMessageSummary = '管理者の方へ';
                    additionalMessageDetails =
                        'シングルサインオン設定が無効です。設定に誤りがあるか、AzureADの場合クライアントシークレットの有効期限切れの可能性があります。';
                } else {
                    errorMessage = 'スマイルネクストに未登録のアカウントです。管理者に連絡してください。';
                }
                break;
        }

        this.dispatch(
            new DisplayedErrorMessagePayload(errorMessage, additionalMessageSummary, additionalMessageDetails),
        );
    }
}
